import React, { useContext, JSX } from 'react';
import { ApiBooking, ApiDocument } from '@ibe/api';
import { Col, Row } from 'reactstrap';

import useTranslation from '../../Hooks/useTranslation';
import fallback from '../../../_Translations/generated/booking-documents.en.t.json';
import Keys from '../../../_Translations/generated/booking-documents.en.t.json.keys';

import DateDisplay from '../UI/DateDisplay/DateDisplay';
import { useLocalObservable } from 'mobx-react';
import useApi from '../../Hooks/useApi';
import { documentStoreContext } from '../../../Models/Stores/DocumentStore';
import DocumentDownloadLink from '../UI/DownloadLink/DocumentDownloadLink';

export interface BookingDocumentsProps {
  booking: ApiBooking;
  bookingId?: string;
}

const BookingDocuments = (props: BookingDocumentsProps): JSX.Element => {
  const { booking, bookingId = booking.id } = props;
  const { t } = useTranslation('booking-documents', fallback, Keys);
  const api = useApi();

  const storeContext = useContext(documentStoreContext);
  const store = useLocalObservable(() => storeContext);
  store.setApi(api);

  return (
    <>
      {booking && (
        <>
          <Row>
            <Col xs="12">
              <div className="iso__bookingDetailsModule_header_medium mb-2">
                {t(Keys.documents)}
              </div>
            </Col>
          </Row>
          {booking.documents && booking.documents.length > 0 ? (
            booking.documents.map((document: ApiDocument) => (
              <div key={`${document.fileName}-${document.number}`} className="border-bottom">
                <Row>
                  <Col className="iso__bookingDetailsModule_header_regular">
                    {t(`documentType.${document.type}`)}
                  </Col>
                </Row>
                <Row className="mb-2 justify-content-between">
                  <Col xs="12" md="6">
                    {t(Keys.issued)}: <DateDisplay date={document.issuedDate} />,{' '}
                    {t(Keys.recipient)}: {document.recipientAddress}
                  </Col>
                  <Col xs="12" md="auto">
                    <DocumentDownloadLink store={store} bookingId={bookingId} document={document}>
                      {t(Keys.viewSave)}
                    </DocumentDownloadLink>
                  </Col>
                </Row>
              </div>
            ))
          ) : (
            <Row>
              <Col>{t(Keys.noDocuments)}</Col>
            </Row>
          )}
        </>
      )}
    </>
  );
};

export default BookingDocuments;
